import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Card,
  Table,
  Descriptions,
  Spin,
  Typography,
  Divider,
  Tag,
  Button,
  Select,
  Modal,
  notification,
} from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { apiHandle } from "../../config/apiHandle";
import { useDispatch, useSelector } from "react-redux";
import { ShopOutlined } from "@ant-design/icons";
import { getAllStoresAsync } from "../../services/StoreManagementServices";

const { Title } = Typography;

const orderStatuses = ["Unfulfilled", "Fulfilled", "Ready for Pickup"];
const paymentStatuses = [
  "Paid",
  "Unpaid",
  "Refunded",
  "Partially Paid",
  "Partially Refunded",
];
const paymentMethods = ["cod", "card"];
const DeliveredMethods = ["Delivered", "In Transit", "Delayed"];

const OrderPreview = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { get_all_stores_data, get_all_stores_status } = useSelector(
    (state) => state.storeManagement
  );

  const { user } = useSelector(
    (state) => state.userAuth
  );

  const { get_order_by_id_data } = useSelector(
    (state) => state.orderManagement
  );

  console.log(get_order_by_id_data , user , "get by order ")
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updatedTotal, setUpdatedTotal] = useState(0);
  const [updatedSubtotal, setUpdatedSubtotal] = useState(0);
  const [updatedVariants, setUpdatedVariants] = useState({});
  const [orderStatus, setOrderStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [DelMethod, setDelMethod] = useState("");

  const [assignmentModalVisible, setAssignmentModalVisible] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [assigning, setAssigning] = useState(false);
  const [store  ,setStore] = useState(null)

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const response = await apiHandle.get(`/view-order/${id}`);
        const fetchedOrder = response.data.data;
        setOrder(fetchedOrder);
        setUpdatedTotal(fetchedOrder.totalAmount);
        setUpdatedSubtotal(fetchedOrder.subtotal);
        setOrderStatus(fetchedOrder.orderStatus);
        setPaymentStatus(fetchedOrder.paymentStatus);
        setPaymentMethod(fetchedOrder.paymentMethod);
        setStore(fetchedOrder.store)
        setUpdatedVariants(
          fetchedOrder.order_items.reduce((acc, item) => {
            item.product_id.variants.forEach((variant) => {
              const isSelected = item.variants.some(
                (sku) => sku === variant.sku
              );
              acc[variant.sku] = isSelected;
            });
            return acc;
          }, {})
        );
      } catch (error) {
        console.error("Error fetching order:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [id]);

  const toggleVariantSelection = (variantId, price, discount) => {
    const actualPrice = price - (price * discount) / 100; // Apply discount
    setUpdatedVariants((prevVariants) => {
      const newVariants = { ...prevVariants };
      newVariants[variantId] = !newVariants[variantId]; // Toggle selection

      setUpdatedSubtotal((prevSubtotal) =>
        newVariants[variantId] ? prevSubtotal + price : prevSubtotal - price
      );

      setUpdatedTotal((prevTotal) =>
        newVariants[variantId] ? prevTotal + price : prevTotal - price
      );

      console.log("Updated Variants:", newVariants);
      console.log(
        "Updated Subtotal:",
        newVariants[variantId]
          ? updatedSubtotal + price
          : updatedSubtotal - price
      );
      console.log(
        "Updated Total Amount:",
        newVariants[variantId] ? updatedTotal + price : updatedTotal - price
      );

      return newVariants;
    });
  };

  const handleOrderStatusChange = (value) => {
    setOrderStatus(value);
    console.log("Updated Order Status:", value);
  };

  const handlePaymentStatusChange = (value) => {
    setPaymentStatus(value);
    console.log("Updated Payment Status:", value);
  };

  const handlePaymentMethodChange = (value) => {
    setPaymentMethod(value);
    console.log("Updated Payment Method:", value);
  };
  const handleDelMethodChange = (value) => {
    setDelMethod(value);
    console.log("Updated Payment Method:", value);
  };

  const handleAssignToStore = async () => {
    // if (!selectedStore || !selectedVariant) return;
    if (!selectedStore) return;

    try {
      // console.log("Assignment successful", {
      //     storeId: selectedStore,
      //     variantSKU: selectedVariant,
      //     orderId: order.order_id
      // });

      const response = await apiHandle.post("admin/assign-store", {
        storeId: selectedStore,
        // variantSKU: selectedVariant,
        orderId: order.order_id,
      });

      notification.success({
        message: "Assignment successful",
      });
      console.log("Assignment successful:", response.data);
      // Add success notification here
    } catch (error) {
      notification.error({
        message: "Assignment failed",
      });
      console.error("Assignment failed:", error);
      // Add error notification here
    } finally {
      setAssignmentModalVisible(false);
      setSelectedStore(null);
      setSelectedVariant(null);
    }
  };

  useEffect(() => {
    dispatch(getAllStoresAsync());
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!order) {
    return (
      <p style={{ textAlign: "center", color: "red" }}>Order not found.</p>
    );
  }

  const transformedData = order?.order_items?.flatMap(
    (item) =>
      item?.product_id?.variants
        ?.map((variantObj) => ({
          productName: item.product_id.name,
          sku: variantObj.sku,
          variantDetails: [
            { type: "Size", value: variantObj.Size },
            { type: "Fabric", value: variantObj.Fabric },
            { type: "Finishing", value: variantObj.Finishing },
          ],
          originalPrice: variantObj.price,
          price: variantObj.discount,
          discount: (
            ((variantObj.price - variantObj.discount) / variantObj.price) *
            100
          ).toFixed(2),
          stock: variantObj.stock_quantity,
          isSelected: updatedVariants[variantObj.sku] || false,
          variantId: variantObj.sku,
        }))
        ?.filter((variant) => variant.isSelected) // Add this filter
  );

  return (
    <div style={{ maxWidth: "1200px", margin: "auto", padding: "20px" }}>
      {/* Assign Modal */}
      {assignmentModalVisible && (
        <Modal
          title={
            <div
              style={{ fontSize: "20px", fontWeight: "bold", color: "#1890ff" }}
            >
              📦 Assign this Order to Store
            </div>
          }
          visible={assignmentModalVisible}
          onOk={handleAssignToStore}
          onCancel={() => {
            setAssignmentModalVisible(false);
            setSelectedStore(null);
          }}
          okText={assigning ? <Spin size="small" /> : "Confirm Assignment"}
          cancelText="Cancel"
          okButtonProps={{
            style: {
              backgroundColor: "#1890ff",
              borderColor: "#1890ff",
              borderRadius: "4px",
              color: "#fff"
            },
            disabled: assigning || !selectedStore,
          }}
          cancelButtonProps={{
            style: {
              borderColor: "#d9d9d9",
              borderRadius: "4px",
            },
          }}
          bodyStyle={{ padding: "24px" }}
        >
          <div style={{ marginBottom: "16px" }}>
            {/* <p style={{ marginBottom: "8px", fontWeight: 500 }}>
              Selected Variant:{" "}
              <span style={{ color: "#1890ff" }}>{selectedVariant?.sku}</span>
            </p> */}
            <p style={{ marginBottom: "16px", color: "#666" }}>
              {selectedVariant?.variantDetails
                .map((d) => `${d.type}: ${d.value}`)
                .join(", ")}
            </p>
          </div>

          <Select
            placeholder="🏪 Select a store"
            style={{ width: "100%" }}
            onChange={(value) => setSelectedStore(value)}
            value={selectedStore}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={assigning}
          >
            {get_all_stores_data?.stores?.length > 0 ? (
              get_all_stores_data.stores.map((store) => (
                <Select.Option
                  key={store._id}
                  value={store._id}
                  style={{ padding: "8px 12px" }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span>{store.name}</span>
                    <span style={{ color: "#666", marginLeft: "16px" }}>
                      {store?.address?.city}, {store?.address?.state}
                    </span>
                  </div>
                </Select.Option>
              ))
            ) : (
              <Select.Option disabled>
                <span style={{ color: "#999" }}>No stores available</span>
              </Select.Option>
            )}
          </Select>

          {!get_all_stores_data?.stores?.length && (
            <p style={{ color: "#ff4d4f", marginTop: "8px" }}>
              No stores found. Please create stores first.
            </p>
          )}
        </Modal>
      )}
      {/* Assign Modal */}

      {/* Customer Info */}
      <Card title="Customer Information" bordered>
        <Descriptions column={2} bordered>
          <Descriptions.Item label="Name">
            {order.customer_info.firstName} {order.customer_info.lastName}
          </Descriptions.Item>
          <Descriptions.Item label="Business Name">
            {order.customer_info.businessName}
          </Descriptions.Item>
          <Descriptions.Item label="Address">
            {`${order.customer_info.address}, ${order.customer_info.city}, ${order.customer_info.province}, ${order.customer_info.country} - ${order.customer_info.postalCode}`}
          </Descriptions.Item>
          <Descriptions.Item label="Apartment">
            {order.customer_info.apartment}
          </Descriptions.Item>
          <Descriptions.Item label="Phone">
            {order.customer_info.phone}
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            {order.customer_info.email}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Divider />
      {
        user.role === 'Admin' && 
      <div
        style={{ background: "#fff", margin: "10px 0px", padding: "10px 0px" }}
      >
{store ? <div className="flex items-center gap-10 px-[24px]"> <p>{store.name} </p> <Button
          type="dashed"
          ghost
          icon={<ShopOutlined />}
          onClick={() => {
            //   setSelectedVariant(record);
            setAssignmentModalVisible(true);
          }}
          style={{
            borderRadius: "4px",
            borderColor: "#1890ff",
            backgroundColor: "#1890ff",
            color: "#fff",
          }}
        >
          Change  Store
        </Button> 
        </div>:
        <Button
          type="dashed"
          ghost
          icon={<ShopOutlined />}
          onClick={() => {
            //   setSelectedVariant(record);
            setAssignmentModalVisible(true);
          }}
          style={{
            borderRadius: "4px",
            borderColor: "#1890ff",
            backgroundColor: "#1890ff",
            color: "#fff",
            padding: "0px 24px"
          }}
        >
          Assign to Store
        </Button>
        }
      </div>
      }
      {/* Order Details */}
      <Card title={`Order #: ${order.order_id}`} bordered>
        <Descriptions column={2} bordered>
          <Descriptions.Item label="Order Status">
            <Select
              value={orderStatus}
              onChange={handleOrderStatusChange}
              style={{ width: 200 }}
            >
              {orderStatuses?.map((status) => (
                <Select.Option key={status} value={status}>
                  {status}
                </Select.Option>
              ))}
            </Select>
          </Descriptions.Item>
          <Descriptions.Item label="Payment Status">
            <Select
              value={paymentStatus}
              onChange={handlePaymentStatusChange}
              style={{ width: 200 }}
            >
              {paymentStatuses?.map((status) => (
                <Select.Option key={status} value={status}>
                  {status}
                </Select.Option>
              ))}
            </Select>
          </Descriptions.Item>
          <Descriptions.Item label="Payment Method">
            <Select
              value={paymentMethod}
              onChange={handlePaymentMethodChange}
              style={{ width: 200 }}
            >
              {paymentMethods?.map((method) => (
                <Select.Option key={method} value={method}>
                  {method.toUpperCase()}
                </Select.Option>
              ))}
            </Select>
          </Descriptions.Item>

          <Descriptions.Item label="Delivery Status">
            <Select
              value={DelMethod}
              onChange={handleDelMethodChange}
              style={{ width: 200 }}
            >
              {DeliveredMethods?.map((method) => (
                <Select.Option key={method} value={method}>
                  {method.toUpperCase()}
                </Select.Option>
              ))}
            </Select>
          </Descriptions.Item>
        </Descriptions>
      </Card>

      {/* Order Items */}
      <Card title="Order Items" bordered style={{ marginTop: "10px" }}>
        <Table
          dataSource={transformedData}
          rowKey="variantId"
          pagination={false}
          locale={{ emptyText: "No selected variants found" }}
        >
          <Table.Column
            title="Product Name"
            dataIndex="productName"
            key="productName"
          />
          <Table.Column title="SKU" dataIndex="sku" key="sku" />
          <Table.Column
            title="Variants"
            key="variant"
            render={(record) => (
              <ul>
                {record?.variantDetails?.map((v) => (
                  <li key={v._id}>
                    <strong>{v.type}:</strong> {v.value}
                  </li>
                ))}
                <Tag color="green" icon={<CheckCircleOutlined />}>
                  Selected
                </Tag>
              </ul>
            )}
          />
          <Table.Column
            title="Original Price ($)"
            dataIndex="originalPrice"
            key="originalPrice"
          />
          <Table.Column
            title="Discounted Price ($)"
            dataIndex="price"
            key="price"
          />
          <Table.Column
            title="Discount (%)"
            dataIndex="discount"
            key="discount"
          />
          <Table.Column title="Stock" dataIndex="stock" key="stock" />
          {/* <Table.Column
                        title="Actions"
                        key="actions"
                        render={(record) => (
                            <Button
                                type="primary"
                                ghost
                                icon={<ShopOutlined />}
                                onClick={() => {
                                    setSelectedVariant(record);
                                    setAssignmentModalVisible(true);
                                }}
                                style={{
                                    borderRadius: '4px',
                                    borderColor: '#1890ff',
                                    color: '#1890ff'
                                }}
                            >
                                Assign to Store
                            </Button>
                        )}
                    /> */}
        </Table>
      </Card>

      <Divider />

      <Divider />

      {/* Order Summary */}
      <Card title="Order Summary" bordered>
        <Descriptions column={1} bordered>
          <Descriptions.Item label="Shipping Cost">
            ${order.shippingCost}
          </Descriptions.Item>
          <Descriptions.Item label="Tax Amount">
            ${order.taxAmount}
          </Descriptions.Item>
          <Descriptions.Item label="Discount Amount">
            ${order.discountAmount}
          </Descriptions.Item>
          <Descriptions.Item label="Subtotal">
            ${updatedSubtotal.toFixed(2)}
          </Descriptions.Item>
          {/* <Descriptions.Item label="Paid Amount">${order.paidAmount?.toFixed(2)}</Descriptions.Item> */}
          <Descriptions.Item label="Paid Amount">$0.00</Descriptions.Item>
          <Descriptions.Item label="Total Amount">
            <strong>${updatedTotal.toFixed(2)}</strong>
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </div>
  );
};

export default OrderPreview;
